module.exports = __webpack_public_path__ + "img/form-1.2e8b7bfb.png";